const ZoomController = ({ zoomIn, zoomOut, reset }) => {
    return (
      <div>
        <button onClick={zoomIn}>+</button>
        <button onClick={zoomOut}>-</button>
        <button onClick={reset}>Reset</button>
      </div>
    );
  };

  export default ZoomController